/* eslint-disable no-unused-vars */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import ChatRoomItem from "./components/ChatRoomItem";
import ChatNewsItem from "./components/ChatNewsItem";

import BuddibleSocket, { MsgIDList } from "../../lib/BuddibleSocket";
import Utilities from "../../lib/Utilities";
import CodeList from "../../lib/CodeList";
import { useTranslation } from "react-i18next";

const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

export default function ChatRoomList(props) {
  const {
    loginInfo,
    chatRoomList,
    openNewsChatRoom,
    newsChatList,
    actionSubscribe,
    alertDisabledList,
    updateAlertDisable,
    addActiveChRoom,
  } = props;
  const { t } = useTranslation();
  const [isSearch, setIsSearch] = useState(false);
  const [searchText, setSearchText] = useState("");
  const searchBox = useRef();

  useEffect(() => {
    if (searchBox.current) searchBox.current.value = "";
    setSearchText("");
  }, [isSearch]);

  const ChatRoomItemRender = useCallback((props) => {
    return <ChatRoomItem {...props} />;
  }, []);

  const ChatNewsItemRender = useCallback((props) => {
    return <ChatNewsItem {...props} />;
  }, []);

  const mappedData = useMemo(() => {
    return util.arraySort([...chatRoomList, ...newsChatList], "LastTime", true);
  }, [chatRoomList, newsChatList]);

  //채팅방 나가기
  function EVENT_SOCKET_TALK_LEAVE_ROOM(chat) {
    codeList.Modal.current.confirm(
      `"${chat.chatRoomTitle}" ${t(
        "logiTalk.chatList.msg.confirmLeaveChatRoom"
      )}`,
      (ret) => {
        if (!ret) return;
        const msgID = util.makeUUIDv4();
        const data = {
          method: MsgIDList.EVENT_SOCKET_TALK_LEAVE_ROOM,
          msgID: msgID,
          data: {
            crtMainKey: chat.crmMainKey, //룸 메인키
            crtMSGKey: chat.crtMSGKey, //생성 메세지키
            crtType: 3, //시스템메세지로세팅
            crtMSG: `[${loginInfo.comp_nm}] ${
              loginInfo.USER_NICK || loginInfo.USER_NM
            }${t("logiTalk.chatList.msg.leftChatRoom")}`, //출력할내용
            crtFile: "",
            crmLastMSG: `[${loginInfo.comp_nm}] ${
              loginInfo.USER_NICK || loginInfo.USER_NM
            }${t("logiTalk.chatList.msg.leftChatRoom")}`, //출력할내용
            crtCreator: loginInfo.user_id, //나가는사람 ID
            crtCreatorSite: loginInfo.comp_cd, //나가는사람 COMP_CD
            senderCompCD: loginInfo.comp_cd,
            senderUserID: loginInfo.user_id,
            senderUserName: loginInfo.user_nm,
            senderUserNICK: loginInfo.USER_NICK || loginInfo.USER_NM,
            senderUserPART: loginInfo.USER_PART_NM,
            senderUserTEAM: loginInfo.USER_TEAM_NM,
            senderUserPIC: loginInfo.USER_PIC,
          },
        };
        if (Number(chat.crmType) !== 1) {
          socket.sendSocketMessage(data, msgID, (beforeData, newData) => {
            if (newData) {
              if (!newData.ret) {
                codeList.Modal.current.alert(t("commonMSG.error"));
              }
            }
          });
        }
      }
    );
  }

  // 채팅방 이름 변경 모달 호출
  function openChangeChatRoomTitleModal(chat) {
    socket.fireLocalEventListener(
      MsgIDList.EVENT_CHANGE_CHAT_ROOM_TITLE_MODAL_CALL,
      "ChatRoomItem",
      chat
    );
  }

  return (
    <div className="bg-white py-2 w-100 h-100 overflow_scroll scroll_hidden">
      <div className="py-2 px-3 d-flex flex-row justify-content-between align-items-center">
        <h6 className="text-info font-weight-bold pb-2 mb-0">
          {t("logiTalk.chatList.title")}
        </h6>
        <span
          className="px-1 cursor_pointer"
          onClick={() => {
            setIsSearch(!isSearch);
          }}
        >
          <i
            className={
              !isSearch ? "fa-solid fa-magnifying-glass" : "fa-solid fa-xmark"
            }
          />
        </span>
      </div>
      {isSearch && (
        <div className="pb-3 px-3">
          <input
            ref={searchBox}
            type="text"
            className="form-control p-1 bg-light border-0 rounded"
            placeholder={t("logiTalk.chatList.placeholder")}
            onChange={(e) => {
              setSearchText(e.target.value);
            }}
          />
        </div>
      )}

      <div>
        {mappedData.map((item, index) => {
          if (item.hasOwnProperty("cnmMainKey")) {
            return (
              <ChatNewsItemRender
                key={item.cnmMainKey}
                item={item}
                searchText={searchText}
                openNewsChatRoom={openNewsChatRoom}
                actionSubscribe={actionSubscribe}
                alertDisabledList={alertDisabledList}
                updateAlertDisable={updateAlertDisable}
              />
            );
          }

          return (
            <ChatRoomItemRender
              key={item.crmMainKey}
              chat={item}
              loginInfo={loginInfo}
              searchText={searchText}
              addActiveChRoom={addActiveChRoom}
              alertDisabledList={alertDisabledList}
              updateAlertDisable={updateAlertDisable}
              openChangeChatRoomTitleModal={openChangeChatRoomTitleModal}
              EVENT_SOCKET_TALK_LEAVE_ROOM={EVENT_SOCKET_TALK_LEAVE_ROOM}
            />
          );
        })}
      </div>
    </div>
  );
}
